import cx from "classnames";
import type { ReactNode } from "react";

import CS from "metabase/css/core/index.css";

import S from "./FieldSet.module.css";

interface FieldSetProps {
  className?: string;
  legend?: string;
  required?: boolean;
  noPadding?: boolean;
  legendVisuallyHidden?: boolean;
  unstyled?: boolean;
  children: ReactNode;
}

export function FieldSet({
  className,
  legend,
  required = false,
  noPadding = false,
  legendVisuallyHidden = false,
  unstyled = false,
  children,
}: FieldSetProps) {
  const fieldSetClassName = unstyled
    ? cx(className, S.unstyled)
    : cx(className ?? CS.borderBrand, CS.bordered, CS.rounded, {
        [cx(CS.px2, CS.pb2)]: !noPadding,
      });

  return (
    <fieldset data-testid="field-set" className={fieldSetClassName}>
      {legend && (
        <legend
          data-testid="field-set-legend"
          className={cx(
            CS.h5,
            CS.textBold,
            CS.textUppercase,
            CS.px1,
            CS.textNoWrap,
            CS.textSecondary,
            { [S.srOnly]: legendVisuallyHidden },
          )}
        >
          {legend}
          {required && <span>&nbsp;*</span>}
        </legend>
      )}
      <div data-testid="field-set-content" className={CS.wFull}>
        {children}
      </div>
    </fieldset>
  );
}
